import React from 'react'
import ResultNoticePanel from "./ResultNoticePanel";

function Index(
    {
        expanded
    }) {
    return (expanded && <ResultNoticePanel/>)
}


export default Index;